import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'vrm-video-player',
  templateUrl: './vrm-video-player.component.html',
  styleUrls: ['./vrm-video-player.component.scss'],
})
export class VrmVideoPlayerComponent implements OnInit {
  private controlListMapping = {
    disableFullScreen: 'nofullscreen',
    disableDownload: 'nodownload',
    disableRemotePlayback: 'noremoteplayback',
  };

  public controlsList: string;

  @Input() autoplay: boolean = false;
  @Input() controls: boolean = true;
  @Input() enableFullScreen: boolean = true;
  @Input() enableDownload: boolean = true;
  @Input() enableRemotePlayBack: boolean = true;
  @Input() src: any;
  @Input() streamSource: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.streamSource = this.sanitizer.bypassSecurityTrustResourceUrl(this.src);
    this.configureControlsList();
  }

  configureControlsList(): void {
    const controls = [];

    if (!this.enableFullScreen) {
      controls.push(this.controlListMapping.disableFullScreen);
    }

    if (!this.enableDownload) {
      controls.push(this.controlListMapping.disableDownload);
    }

    if (!this.enableRemotePlayBack) {
      controls.push(this.controlListMapping.disableRemotePlayback);
    }

    this.controlsList = controls.join(' ');
  }
}
